import { useAuth } from '@/context/AuthContext';
import { useEffect } from 'react';

export const useIntercomSupport = () => {
  const { user } = useAuth();

  useEffect(() => {
    const bootIntercom = () => {
      //@ts-expect-error find intercom should use react use-intercom
      if (typeof window.Intercom === 'function') {
        //@ts-expect-error find intercom should use react use-intercom
        window.intercomSettings = {
          app_id: 'u9yuy4xj',
          custom_launcher_selector: '#intercom_support',
        };

        if (user) {
          //@ts-expect-error find intercom should use react use-intercom
          window.Intercom('boot', {
            app_id: 'u9yuy4xj',
            name: user?.displayName,
            email: user?.email,
            plan: user.subscription?.[0]?.plan || 'FREE',
            user_id: user?.id,
          });
        } else {
          //@ts-expect-error find intercom should use react use-intercom
          window.Intercom('boot', {
            app_id: 'u9yuy4xj',
          });
        }
      } else {
        setTimeout(bootIntercom, 50);
      }
    };

    bootIntercom();
  }, [user]);
};
